import { z } from 'zod';

import {
  storeAddressSchema,
  storeDetailsSchema,
  storePhotosSchema,
} from '../../model/schemas';

const coordinatesSchema = z
  .object({ lat: z.number(), lng: z.number() })
  .nullable();

export const storeDataSchema = z
  .object({
    details: storeDetailsSchema,
    address: storeAddressSchema.optional(),
    coordinates: coordinatesSchema.optional(),
    photos: storePhotosSchema.optional(),
  })
  .refine(
    (data) => {
      if (data.details.type === 'OFFLINE') {
        return (
          data.address !== undefined &&
          data.coordinates !== undefined &&
          data.photos !== undefined
        );
      }
      return true;
    },
    {
      message: 'Offline store requires address, coordinates, and photos',
      path: ['details'],
    }
  );
